export const stylesColors = [
    'red', 'green', 'blue', 'yellow', 'grey', 'default'
];

export const stylesList = [
    {
        'name': 'Actual vs Budget',
        'code': 'style = actual - budget < 0 ? "style-red": (actual - budget > 0 ? "style-green": "")'
    },
    {
        'name': 'Month vs Budget',
        'code': 'style = value < 0 ? "style-red": (value > 0 ? "style-green": "")'
    },
    {
        'name': 'Semaphore %',
        'code': 'style = value < 50 ? "style-red": (value < 80 ? "bg-warning text-light": "style-green")'
    },
    {
        'name': 'PTQR',
        'code': '{"emptyColor":"default","minColor":"red","midColor":"yellow","maxColor":"green","minValue":1.5,"maxValue":2.5}'
    }
];

export const metricList = {
    "monthly": '{"amount": 20,"condition": 0,"format": 2,"period": 0}',
    "weekly": '{"amount": 20,"condition": 0,"format": 2,"period": 2}',
};

export const metricOptions = {
    "formats": {"2": "%", "4": "X"},
    "conditions": ["Less than goal", "Below goal", "Increase of"],
    "periods": ["Within Month", "Last Three Months", "Within Week"]
}

export const getActualClass = function(style, data, report, date, selectedYear, inverted) {
    var today = new Date();
    const newDate = new Date(date);

    if (today.getTime() < newDate.getTime()) return;
    const actual = data.actual * 1;
    const budget = data.budget * 1;

    if (style && style[0] === '{') {
        const rules = JSON.parse(style);
        style = rules.emptyColor || '';

        if (actual <= rules.minValue && actual !== 0) {
            style = rules.minColor || '';
        } else if ( actual >= rules.maxValue) {
            style = rules.maxColor || '';
        } else if ( actual !== 0) {
            style = rules.midColor || '';
        }

        style = 'style-' + style;
    } else {
        if (!inverted) {
            style = actual - budget < 0 ? "style-red": (actual - budget >= 0 ? "style-green": "");
        } else {
            style = actual - budget > 0 ? "style-red": (actual - budget <= 0 ? "style-green": "");
        }
    }

    return style;
}

export const getMonthlyClass = function(style, value, report) {
    value = (value + '').replace('%','') * 1;

    if (style && style[0] === '{') {
        const rules = JSON.parse(style);
        style = rules.emptyColor || '';

        if (value <= rules.minValue && value !== 0) {
            style = rules.minColor || '';
        } else if ( value >= rules.maxValue) {
            style = rules.maxColor || '';
        } else if ( value !== 0) {
            style = rules.midColor || '';
        }

        style = 'style-' + style;
    } else {
        style = value < 0 ? "style-red": (value >= 0 ? "style-green": "");
    }

    return style;
}

const monthsList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const getPastDateData = function(value, date, type, year = null, start_date = null, end_date = null, isAttainment = false) {
    //------Type options ------ //
    // "weekly" for weekly report
    // "monthly" for yearly actual vs budget, quota and attainment.
    // "quarterly" for monthly quarterly and monthly attainment
    value = (value || 0).toString().replace("$","").replace("%","").replace("x","");
    if(((parseFloat(value) && value != "0.00") || date == 'Last 12 mo. Attainment') && !isAttainment){
        //It's not necessary to verify the dates because it's not zero and also avoid last 12 mo attainment field.
        return '';
    }

    //Get today date
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    var yyyy = today.getFullYear();

    const columnDateUnix = new Date(date).getTime();
    const startDateUnix = start_date ? new Date(setFirstMonthDay(start_date)).getTime() : false;
    const endDateUnix = end_date ? new Date(setFirstMonthDay(end_date)).getTime() : false;

    // is individual report
    if (startDateUnix) {
        const currentMonthUnix = new Date(`${mm}/01/${yyyy}`).getTime();
        // range out of employee company period
        if ((endDateUnix && columnDateUnix > endDateUnix) || startDateUnix > columnDateUnix) return 'style-grey';
        if (columnDateUnix >= currentMonthUnix) return 'style-white';
        if (value == 0) return 'style-red';
        return 'style-white';
    }

    today = mm + '/' + dd + '/' + yyyy;
    if(start_date){
        let startDateSplitted = start_date.substr(0,10).split("-");
        start_date = startDateSplitted[1] + "/" + startDateSplitted[2] + "/" + startDateSplitted[0];
    }
    if(end_date){
        let endDateSplitted = end_date.substr(0,10).split("-");
        end_date = endDateSplitted[1] + "/01/" + endDateSplitted[0];
    }

    // Avoid adding style to employees with end date
    if (isAttainment) {
        const endDateFormatted = new Date(end_date);
        const cellDateFormatted = new Date(date);
        if (endDateFormatted.getTime() < cellDateFormatted.getTime() && value == -1) return 'style-white';
        else return 'style-red';
    }

    switch(type){
        case 'monthly':
            let dateSplitted = date.split("/");
            let lastDayMonth = new Date(dateSplitted[1], monthsList.indexOf(dateSplitted[0] ) + 1, 0);
            date =   String(lastDayMonth.getMonth() + 1).padStart(2, '0') + "/" + String(lastDayMonth.getDate()).padStart(2, '0') + "/" + dateSplitted[1];
            break;
        case 'quarterly':
            if(date.includes(" Prior Year")){
                year -= 1;
                date = date.substring(0,2);
            }
            switch (date) {
                case "q1":
                    date = "03/31/" + year;
                    break;
                case "q2":
                    date = "06/30/" + year;
                    break;
                case "q3":
                    date = "09/30/" + year;
                    break;
                default:
                    date = "12/31/" + year;
                    break;
            }
    }
    // Date comparation doesn't include the year, so it's necessary to compare the year before
    if(!year){
        year = date.split("/")[2];
    }
    // Avoid validation for dates in the future
    if(year > yyyy || (year == yyyy && date >= today)) return 'style-white';
    // For individual reports, it's necessary to check if the start date is greater than the date 
    // Also, it's necessary to check if end date is greater than the date to apply any style
    if(start_date && (start_date.split("/")[2] > year || (start_date.split("/")[2] == year && start_date > date))
         || (end_date && (end_date.split("/")[2] < year || (end_date.split("/")[2] == year && end_date.split("/")[0] < date.split("/")[0])))){
        return '';
    }
    return (year < yyyy || date < today) ? 'style-red' : '';
}

export const getQuarterlyStyle = function(style, formula, actual, budget, inverted) {
    actual = (actual || 0 + '').replace('%','') * 1;
    budget = (budget || 0 + '').replace('%','') * 1;

    if (style && style[0] === '{') {
        const rules = JSON.parse(style);

        // Apply inverted styles to custom rules
        if (rules && inverted) {
            const minColor = rules.minColor;
            rules.minColor = rules.maxColor;
            rules.maxColor = minColor;
        }

        style = rules.emptyColor || '';

        if(formula === 'SUM'){
            if (actual <= rules.minValue * 3 && actual !== 0) {
                style = rules.minColor || '';
            } else if ( actual >= rules.maxValue * 3) {
                style = rules.maxColor || '';
            } else if ( actual !== 0) {
                style = rules.midColor || '';
            }
        }else{
            if (actual <= rules.minValue && actual !== 0) {
                style = rules.minColor || '';
            } else if ( actual >= rules.maxValue) {
                style = rules.maxColor || '';
            } else if ( actual !== 0) {
                style = rules.midColor || '';
            }
        }

        style = 'style-' + style;
    } else {
        style = (inverted && actual - budget > 0) || (!inverted && actual - budget < 0) ? 'style-red' : 'style-green';
    }

    return style;
}

export const getPtqrCellStyle = (value, rules) => {
    const parsedRules = rules ? JSON.parse(rules) : JSON.parse(stylesList[3].code);

    if(value === 0){
        return parsedRules.emptyColor;
    }
    if (value < parsedRules.minValue) {
        return parsedRules.minColor;
    }
    if (value >= parsedRules.minValue && value < parsedRules.maxValue) {
        return parsedRules.midColor;
    }

    return parsedRules.maxColor;
};

export const getColorFromStyle = (style) => {
    const colors = {
        grey: 'f2f2f2',
        red: 'ffc7ce',
        green: 'c6efce',
        default: 'ffffff',
        yellow: 'ffffe0',
        white: 'ffffff',
        blue: 'd2e6ff',
    };

    return colors[style] || colors.default;
};

function setFirstMonthDay(date) {
    const dateSplitted = date.substr(0,10).split('-');
    return `${dateSplitted[1]}-01-${dateSplitted[0]}`;
}